import { createContext } from "react"

let SessionContext = createContext()

export default SessionContext
